import React from 'react';
import styled from 'styled-components';
import { assets } from '../../assets';
import { MattRow } from '../../components/containers/containers';
import { HorizontalSeparator } from '../../components/ui-utils/separators';
import { formatDateTime } from '../../helpers/date-formatters';
import { MessageListItem } from '../../logic/graphql/types/types';
import { FormattedMessage, useIntl } from 'react-intl';

const MessageCardWrapper = styled(MattRow).attrs(() => ({}))<{
  borderColor: string;
}>`
  border: ${(props) => `1px solid ${props.borderColor}`};
  margin-bottom: 10px;
  padding: 16px 20px;
  width: calc(100% - 5px);
  height: 132px;
  cursor: pointer;
  position: relative;
  &:last-of-type {
    margin-bottom: 0px;
  }
`;

const AttachmentIcon = styled.img`
  width: 15px;
  height: 18px;
  margin-right: 4px;
`;

const UrgentIcon = styled.img`
  width: 28px;
  height: 28px;
  position: absolute;
  top: 10px;
  right: 10px;
`;

const ClockIcon = styled.img`
  width: 12px;
  height: 12px;
  margin-right: 4px;
`;

const NewLabel = styled.span`
  background-color: var(--success-color);
  border-radius: 2px;
  padding: 2px 4px;
`;

const TextPreview = styled.p`
  display: block;
  display: -webkit-box;
  max-width: 100%;
  height: 42px;
  margin: 0 auto;
  line-height: 14px;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 8px;
`;

const TitleWrapper = styled.div`
  max-width: calc(100% - 20px);
`;

const MessageCard = (props: {
  message: MessageListItem;
  onClick?: (message: MessageListItem) => void;
  style?: React.CSSProperties | undefined;
  current?: boolean;
}): JSX.Element => {
  const intl = useIntl();
  const handleOnClick = (): void => {
    if (props.onClick) {
      props.onClick(props.message);
    }
  };

  const borderColor = props.current
    ? 'var(--primary-color)'
    : props.message.unread
    ? 'var(--gray-text-color)'
    : 'unset';

  return (
    <MessageCardWrapper onClick={handleOnClick} borderColor={borderColor} style={props.style}>
      <TitleWrapper className="flex flex-row mb-2">
        {props.message.has_attachment ? <AttachmentIcon src={assets.icons.attachment} /> : null}
        <span className="text-12 truncate">
          <b>
            {intl.locale === 'en' && props.message.subject_en !== ''
              ? props.message.subject_en
              : props.message.subject}
          </b>
        </span>
        {props.message.type === 'important' ? (
          <UrgentIcon src={assets.icons.important_message} />
        ) : null}
      </TitleWrapper>
      <TextPreview className="text-10 mb-2">
        {intl.locale === 'en' && props.message.text_en !== ''
          ? props.message.text_en
          : props.message.text}
      </TextPreview>
      <HorizontalSeparator className="mb-2" />
      <div className="flex flex-row justify-between">
        <div className="flex flex-row items-center">
          <ClockIcon src={assets.icons.clock} />
          <span className="text-8 text-lightgray">{formatDateTime(props.message.time)}</span>
        </div>
        {props.message.unread && (
          <NewLabel className="text-8">
            <b>
              <FormattedMessage id="messagesPage.newLabel" />
            </b>
          </NewLabel>
        )}
      </div>
    </MessageCardWrapper>
  );
};

export default MessageCard;
